import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Box, Card, CardContent, Divider, Stack, Typography } from '@mui/material';
import PropTypes from 'prop-types';

function AuditTrailCard({ auditTrail }) {
  const activities =
    auditTrail?.map((item) => {
      const dateObj = new Date(item.transactionDate);

      return {
        title: `${item.transType} - ${item.status}`,
        date: dateObj.toLocaleDateString('en-GB'),
        time: dateObj.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false,
        }),
        ip: item.ipAddress,
        color: item.status === 'SUCCESS' ? '#118C2F' : '#E41F26',
      };
    }) || [];

  return (
    <Card
      sx={{
        borderRadius: '16px',
        border: '1px solid #E4E8ED',
        boxShadow: 'none',
      }}
    >
      <CardContent sx={{ p: 0 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
            p: { xs: 2, sm: 3 },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
            }}
          >
            <AssignmentOutlinedIcon
              sx={{
                color: '#22C55E',
                fontSize: 20,
              }}
            />

            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: 700,
                color: '#1A3655',
              }}
            >
              Audit trail
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
            }}
          >
            <LockOutlinedIcon
              sx={{
                color: '#22C55E',
                fontSize: 16,
              }}
            />

            <Typography
              sx={{
                color: '#22C55E',
                fontSize: '14px',
              }}
            >
              Live
            </Typography>
          </Box>
        </Box>

        <Divider />
        <Box
          sx={{
            p: { xs: 2, sm: 3 },
            maxHeight: 250,
            overflowY: 'auto',
            '&::-webkit-scrollbar': {
              width: 6,
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#C4C4C4',
              borderRadius: 10,
            },
          }}
        >
          {activities.length === 0 && (
            <Typography
              sx={{
                fontSize: '14px !important',
                color: '#98A2B3',
                fontStyle: 'italic',
                textAlign: 'center',
                py: 2,
              }}
            >
              No data found
            </Typography>
          )}
          <Stack spacing={3}>
            {activities.map((item, index) => (
              <Box
                key={`${item.ip}-${index}`}
                sx={{
                  display: 'flex',
                  gap: { xs: 1.5, sm: 2 },
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    sx={{
                      width: 12,
                      height: 12,
                      borderRadius: '50%',
                      bgcolor: item.color,
                    }}
                  />

                  {index !== activities.length - 1 && (
                    <Box
                      sx={{
                        width: '2px',
                        flex: 1,
                        bgcolor: '#DADFE5',
                        minHeight: 40,
                        mt: 0.5,
                      }}
                    />
                  )}
                </Box>
                <Box sx={{ minWidth: 0 }}>
                  <Typography
                    sx={{
                      fontSize: { xs: '14px !important', sm: '16px !important' },
                      fontWeight: 600,
                      color: item.color,
                      overflowWrap: 'anywhere',
                    }}
                  >
                    {item.title}
                  </Typography>

                  {(item.date || item.time) && (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        columnGap: 1.5,
                        rowGap: 0.5,
                        mt: 0.5,
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                        }}
                      >
                        <EventOutlinedIcon
                          sx={{
                            fontSize: 14,
                            color: '#7A7A7A',
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: '14px !important',
                            color: '#666',
                          }}
                        >
                          {item.date}
                        </Typography>
                      </Box>

                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 0.5,
                        }}
                      >
                        <AccessTimeOutlinedIcon
                          sx={{
                            fontSize: 14,
                            color: '#7A7A7A',
                          }}
                        />
                        <Typography
                          sx={{
                            fontSize: '14px !important',
                            color: '#666',
                          }}
                        >
                          {item.time}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  <Typography
                    sx={{
                      mt: 0.75,
                      fontSize: '14px !important',
                      color: '#666',
                      overflowWrap: 'anywhere',
                    }}
                  >
                    IP: {item.ip}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Stack>
        </Box>
      </CardContent>
    </Card>
  );
}

export default AuditTrailCard;

AuditTrailCard.propTypes = {
  auditTrail: PropTypes.array,
};

AuditTrailCard.defaultProps = {
  auditTrail: [],
};
